import { ReactElement } from 'react';
import { Skeleton } from '@bice_vida/ds-components-skeleton';

interface SkeletonCardPropsI {
  numberOfCards: number;
}

const SkeletonCard = ({ numberOfCards }: SkeletonCardPropsI): ReactElement => {
  const singleCard = () => (
    <div
      className={`flex flex-col justify-between gap-8 w-[252px] min-h-[528px] border border-[#AFBACC] rounded-lg p-6 pt-4 relative`}
    >
      <div className="absolute top-1 right-2">
        <Skeleton shape="circle" className="w-8 h-8" />
      </div>
      <div className="flex flex-col justify-between">
        <Skeleton shape="rectangle" className="w-28 h-8 mt-1" />
        <Skeleton shape="rectangle" className="w-30 h-20 mt-6" />
        <Skeleton shape="rectangle" className="w-30 h-6 mt-8" />
        <Skeleton shape="rectangle" className="w-40 h-16 mt-2 ml-1" />
        <Skeleton shape="rectangle" className="w-40 h-16 mt-2 ml-1" />
        <Skeleton shape="rectangle" className="w-40 h-16 mt-2 ml-1" />
      </div>
      <div className="flex justify-center items-center">
        <Skeleton shape="rectangle" className="w-32 h-6" />
      </div>
    </div>
  );

  return (
    <>
      {Array.from({ length: numberOfCards }, (_, index) => (
        <div key={index}>{singleCard()}</div>
      ))}
    </>
  );
};

export default SkeletonCard;
